import React from "react";
import { motion } from "framer-motion";

const fmt = (n) => (n ?? 0).toLocaleString();

export default function AdminAssessments({ data }) {
  const items = data.assessments;
  const maxComp = Math.max(...items.map((a) => a.completions), 1);

  return (
    <div data-testid="admin-assessments">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-500">Assessments</p>
      <h1 className="mt-2 font-heading text-3xl font-light tracking-tight text-slate-50">Assessment performance</h1>
      <p className="mt-2 text-sm text-slate-400">Completions, completion rate and result-type distribution across all 12 assessments.</p>

      <div className="mt-8 space-y-4">
        {items.map((a, i) => (
          <motion.div key={a.slug} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }} className="rounded-2xl border border-slate-800 bg-slate-900 p-5" data-testid={`admin-assess-${a.slug}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="h-3 w-3 rounded-full" style={{ background: a.color }} />
                <div>
                  <h3 className="font-heading text-base font-medium text-slate-100">{a.name}</h3>
                  <p className="text-xs text-slate-500">{a.category}{a.top_type ? ` · Most common: ${a.top_type}` : ""}</p>
                </div>
              </div>
              <div className="flex gap-6 text-right">
                <div><p className="font-heading text-xl font-semibold text-slate-100">{fmt(a.completions)}</p><p className="text-[10px] uppercase tracking-wider text-slate-500">Completions</p></div>
                <div><p className="font-heading text-xl font-semibold text-slate-100">{a.share}%</p><p className="text-[10px] uppercase tracking-wider text-slate-500">Share</p></div>
                <div><p className="font-heading text-xl font-semibold text-slate-100">{a.completion_rate != null ? `${a.completion_rate}%` : "—"}</p><p className="text-[10px] uppercase tracking-wider text-slate-500">Compl. rate</p></div>
              </div>
            </div>

            <div className="mt-4 h-2 overflow-hidden rounded-full bg-slate-800">
              <motion.div initial={{ width: 0 }} animate={{ width: `${(a.completions / maxComp) * 100}%` }} transition={{ delay: i * 0.03 + 0.1, duration: 0.5 }} className="h-full rounded-full" style={{ background: a.color }} />
            </div>

            {a.type_distribution.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-2">
                {a.type_distribution.map((t) => (
                  <span key={t.name} className="rounded-full border border-slate-800 bg-slate-950 px-3 py-1 text-xs text-slate-400">
                    {t.name} <span className="ml-1 font-mono text-slate-300">{t.count}</span>
                  </span>
                ))}
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
